import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_489687c2: FaireBrandEntity = {
  token: "b_489687c2",
  type: "brand",
  name: "Living Royal",
  avatarUrl:
    "https://cdn.faire.com/fastly/e94fe766507ae81189cc72a4c240c64d424103d312357b0163eb4800fe3389e7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5898ea09d09700c5c2803d0a0b45eef21eb90a6705535ec2cb99807fe8818a52.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e94fe766507ae81189cc72a4c240c64d424103d312357b0163eb4800fe3389e7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5898ea09d09700c5c2803d0a0b45eef21eb90a6705535ec2cb99807fe8818a52.png",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 284,
  isTopShop: true,
  isInsider: true,
  description:
    "Living Royal is a Chicago-based brand founded in 2011 by Mariya and Michael, ages 19 and 20.  After realizing there was a lack of fun graphic socks in the market, they decided to create their own high-quality sock that would bring a smile to everyones face. Committing to quality and having a passion for creativity, Michael and Mariya were determined to create socks that were not just garments, but expressions of individuality and happiness. Driven by their shared dream, Michael and Mariya expanded Living Royal beyond socks, venturing into new product categories while staying true to their core values of quality, creativity, and above all, spreading happiness. Living Royal stands true to its belief that even the smallest of gestures—like slipping on a pair of colorful socks—can make a world of difference.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:00.297Z",
    importedBy: "entity-db-cli",
  },
};
